//list hook

import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import store from "../../../redux/store";

import { AEMetadata, useMetadata } from "../../../_emywork/AEPagination";
import { AEButton } from "../../../_emywork/components/buttons";
import { AESVG } from "../../../_emywork/components/svg";
import {
  HTTP_CREATED,
  HTTP_UPDATED,
} from "../../../_emywork/helpers/AxiosHelpers";
import { getFieldNames } from "../../../_emywork/helpers/UIHelper";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from "../../../_metronic/_partials/controls";
import { DeleleteLayout } from "./DeleteLayout";
//hooks for displaying lists
export const useList = ({ actions, CONTEXT }) => {
  const dispatch = useDispatch();

  const { entities, meta, isLoading } = useSelector(
    (state) => state[CONTEXT].list,
    shallowEqual
  );
  const metadata = useMetadata(meta);

  const { page, perPage, sortAsc, filters, sortField, select } = metadata;

  const getEntities = () => {
    dispatch(actions.fetchEntities(metadata.toAEMetadata()));
  };

  useEffect(() => {
    getEntities();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, perPage, filters, select, sortField, sortAsc]);

  return {
    entities,
    metadata,
    isLoading,
  };
};

//Edit hook

export const EditLayout = ({
  CONTEXT,
  actions,
  actionTypes,
  EditForm,
  CONTEXT_TITLE,
  history,
  id = null,
  metadata,
  useModuleContext,
  data = null,
  deleteModalTitle = "",
}) => {
  // Subheader
  const {
    value: { openDeleteDialog },
  } = useModuleContext();
  const { formatMessage } = useIntl();
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  const { isLoading, entity, validationErrors, status } = useSelector(
    (s) => s[CONTEXT][actionTypes.Edit],
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchEntity(id, metadata, actionTypes.Edit));
  }, [id, dispatch]);

  useEffect(() => {
    setTitle(
      formatMessage(
        { id: "FORM.TITLE" },
        { isNew: !id, name: formatMessage({ id: CONTEXT_TITLE.singular }) }
      )
    );
  }, [entity, id]);

  const saveEntity = (values) => {
    if (!id) {
      dispatch(actions.createEntity(values)).then((r) => {
        if (r.status === HTTP_CREATED) {
          history.goBack();
        }
      });
    } else {
      dispatch(actions.updateEntity(values)).then((r) => {
        if (r.status === HTTP_UPDATED) {
          // history.goBack();
        }
      });
    }
  };

  const btnRef = useRef();

  const saveClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  return (
    <>
      <Card>
        {isLoading && <ModalProgressBar />}
        <CardHeader title={title}>
          <CardHeaderToolbar>
            {id && (
              <AEButton
                variant={"light"}
                fontWeight={"bolder"}
                onClick={() => {
                  openDeleteDialog(id);
                }}
                className={"mr-5 text-danger"}
              >
                <AESVG path={"/Navigation/Close.svg"} variant={"danger"} />
                {formatMessage({ id: "DELETE" })}
              </AEButton>
            )}

            <AEButton
              variant={"light"}
              fontWeight={"bolder"}
              onClick={history.goBack}
              className={"mr-2"}
            >
              <AESVG path={"/Navigation/Left-2.svg"} />
              {formatMessage({ id: "BACK" })}
            </AEButton>
            <AEButton
              variant={"light"}
              fontWeight={"bolder"}
              onClick={saveClick}
              type="submit"
              className={"mr-2 text-primary"}
            >
              <AESVG
                path={"/Navigation/Double-check.svg"}
                variant={"primary"}
              />
              {formatMessage({ id: "SAVE" })}
            </AEButton>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <EditForm
            entity={{ ...entity }}
            btnRef={btnRef}
            saveEntity={saveEntity}
            validationErrors={validationErrors}
          />
        </CardBody>
      </Card>
      <DeleleteLayout
        useModuleContext={useModuleContext}
        CONTEXT={CONTEXT}
        CONTEXT_TITLE={CONTEXT_TITLE}
        metadata={metadata}
        actionTypes={actionTypes}
        deleteModalTitle={deleteModalTitle}
        actions={actions}
        history={history}
      />
    </>
  );
};

//use formik for filtering
/**
 *
 * @param filter callback
 * @param initialFilter to initialize formik
 */
export const useFilterFormik = (filter, initialFilter) => {
  const [advancedFilter, setAdvancedFilter] = useState(false);

  const formik = useFormik({
    initialValues: initialFilter,
    onSubmit: (values) => {
      // console.log({ values });
      filter(values);
    },
  });
  return {
    advancedFilter,
    setAdvancedFilter,
    formik,
  };
};
